import { motion } from "framer-motion";
import { useState, useEffect } from "react";

const AnimatedHeadline = () => {
  const words = ["Book", "Ride", "Relax"];
  const [visibleWords, setVisibleWords] = useState([]);
  const [cycle, setCycle] = useState(0);

  useEffect(() => {
    let timeouts = [];

    // reveal each word one by one
    words.forEach((word, i) => {
      timeouts.push(
        setTimeout(() => {
          setVisibleWords((prev) => [...prev, word]);
        }, i * 800)
      );
    });

    // reset after all shown
    timeouts.push(
      setTimeout(() => {
        setVisibleWords([]);
        setCycle((prev) => prev + 1);
      }, words.length * 800 + 1500)
    );

    return () => timeouts.forEach((t) => clearTimeout(t));
  }, [cycle]);

  // Combine all visible words into one string so alignment is stable
  const displayText = visibleWords.join(" | ");

  return (
    <div className="min-h-[80px] flex justify-center items-center overflow-hidden">
      <motion.h1
        key={cycle}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        className="text-white text-center text-4xl sm:text-5xl md:text-6xl font-extrabold drop-shadow-lg"
        style={{ whiteSpace: "nowrap" }}
      >
        {displayText.split(" ").map((char, index) =>
          char === "|" ? (
            <motion.span
              key={index}
              className="text-yellow-400 mx-2"
              animate={{ opacity: [1, 0.3, 1] }}
              transition={{ repeat: Infinity, duration: 1 }}
            >
              |
            </motion.span>
          ) : (
            <motion.span
              key={index}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05, duration: 0.4 }}
            >
              {char}
            </motion.span>
          )
        )}
      </motion.h1>
    </div>
  );
};

export default AnimatedHeadline;
